import { AxnAdminUser, FormattedAxnAdminUser } from "@idw-types/data/axn-admin-user";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { AxnAdminUserAccountStateTypes } from "@enums/axn-admin-user-account-state-types";

export enum OrganizationUsersActionTypes {
    // Organization Users
    SET_ORGANIZATION_USERS_LOADING = "SET_ORGANIZATION_USERS_LOADING",
    SET_ORGANIZATION_USERS = "SET_ORGANIZATION_USERS",
    REPLACE_ORGANIZATION_USER = "REPLACE_ORGANIZATION_USER",
    // Organization Users role filter
    SET_ORGANIZATION_USERS_FILTER_ROLES = "SET_ORGANIZATION_USERS_FILTER_ROLES"
}

// Organization Users
type SetOrganizationUsersLoadingAction = {
    type: OrganizationUsersActionTypes.SET_ORGANIZATION_USERS_LOADING,
    payload: { isLoading: boolean; }
};

export const setOrganizationUsersLoading = (isLoading: boolean): SetOrganizationUsersLoadingAction => ({
    type: OrganizationUsersActionTypes.SET_ORGANIZATION_USERS_LOADING,
    payload: { isLoading }
});

type SetOrganizationUsersAction = {
    type: OrganizationUsersActionTypes.SET_ORGANIZATION_USERS,
    payload: { axnAdminUsers: Array<FormattedAxnAdminUser>; }
}

export const setOrganizationUsers = (axnAdminUsers: Array<FormattedAxnAdminUser>): SetOrganizationUsersAction => ({
    type: OrganizationUsersActionTypes.SET_ORGANIZATION_USERS,
    payload: { axnAdminUsers }
});

// Organization Users role filter
type SetOrganizationUsersRolesAction = {
    type: OrganizationUsersActionTypes.SET_ORGANIZATION_USERS_FILTER_ROLES,
    payload: { organizationUsersRoles: Array<SelectOption>; }
}
export const setOrganizationUsersRoles = (organizationUsersRoles: Array<SelectOption>): SetOrganizationUsersRolesAction => ({
    type: OrganizationUsersActionTypes.SET_ORGANIZATION_USERS_FILTER_ROLES,
    payload: { organizationUsersRoles }
});

type ReplaceOrganizationUserAction = {
    type: OrganizationUsersActionTypes.REPLACE_ORGANIZATION_USER;
    payload: { organizationUser: AxnAdminUser, status: AxnAdminUserAccountStateTypes };
};

export const replaceOrganizationUser = (
    organizationUser: AxnAdminUser,
    status: AxnAdminUserAccountStateTypes
): ReplaceOrganizationUserAction => ({
    type: OrganizationUsersActionTypes.REPLACE_ORGANIZATION_USER,
    payload: { organizationUser, status }
});

export type OrganizationUsersActions =
    // Organization Users
    SetOrganizationUsersLoadingAction |
    SetOrganizationUsersAction |
    SetOrganizationUsersRolesAction | 
    ReplaceOrganizationUserAction;